import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'goalId'>> = ({
  goalId,
}) => {
  if (!goalId) return { isValid: false, message: '골을 선택해주세요.' };
  return { isValid: true };
};
